import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import AnalyticsChartWrapper from './AnalyticsChartWrapper';
import { getTotalContactsImportRequest } from '../../../../../store/actions/possiblePersons';
import Loader from '../../../../_common/Loader/Loader';
import classes from '../analytics.module.scss';
import { useQuery } from '../../../../../utils/hooks/useQuery';

const chartTemplate = {
  series: [],
  options: {
    chart: {
      type: 'radialBar',
    },
    colors: ['#E80054', '#560BAD', '#FFC300', '#7FE47E', '#4A3AFF'],

    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: 'bottom',
      horizontalAlign: 'center',
      floating: true,
      inverseOrder: false,
      onItemClick: {
        toggleDataSeries: true,
      },
    },
    plotOptions: {
      radialBar: {
        inverseOrder: true,
        track: {
          show: true,
          background: '#f2f2f2',
          strokeWidth: '50%',
          opacity: 0.5,
          margin: -30,
        },

        dataLabels: {
          name: {
            show: true,
            fontSize: '25px',
            color: '#000000',
            fontWeight: 700,
            formatter(val, r, k) {
              return k.config.xaxis.categories.find((d) => d.name === val)?.count;
            },
          },
          value: {
            show: true,
            fontSize: '25px',
            color: '#000000',
            fontWeight: 700,
            offsetY: -16,
            formatter() {
              return '';
            },
          },
          total: {
            show: true,
            label: 'Total',
            fontSize: '25px',
            color: '#000000',
            fontWeight: 700,
          },
        },
      },
    },
    labels: [],
    xaxis: {
      categories: [],
    },
  },
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');
const TotalContactsImports = () => {
  const { query, setQuery } = useQuery();

  const {
    tCntId, tCntName, tCntStart, tCntEnd,
  } = query;

  const dispatch = useDispatch();

  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(false);

  const [requestData, setRequestData] = useState({
    start: tCntStart || thisMonthStartDay,
    end: !tCntStart ? thisMonthEndDate : (tCntEnd || ''),
    healthPlanId: tCntId || '',
    healthPlanName: tCntName || '',
  });

  const {
    start, end, healthPlanId, healthPlanName,
  } = requestData;

  const [healthValue, setHealthValue] = useState(tCntName || '');

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { payload: { data } } = await dispatch(getTotalContactsImportRequest(requestData));
      setChart((prev) => ({
        ...prev,
        series: data.data.filter((d) => d.name).map((d) => d.percentage),
        options: {
          ...prev.options,
          plotOptions: {
            radialBar: {
              ...prev.options.plotOptions.radialBar,
              dataLabels: {
                ...prev.options.plotOptions.radialBar.dataLabels,
                total: {
                  ...prev.options.plotOptions.radialBar.dataLabels.total,
                  formatter() {
                    return data.totalCount;
                  },
                },
              },
            },
          },
          xaxis: {
            categories: data.data.map((d) => d),
          },
          labels: data.data.filter((d) => d.name).map((d) => d.name),
        },
      }));

      setQuery({
        ...query, tCntStart: start, tCntEnd: end, tCntId: healthPlanId, tCntName: healthPlanName,
      });

      setLoading(false);
    })();
  }, [requestData]);

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      if (path === 'date') {
        return {
          ...prev,
          start: value[0],
          end: value[1],
        };
      }
      return {
        ...prev,
        [path]: value,
        healthPlanName: planName,
      };
    });
  };

  return (
    <AnalyticsChartWrapper
      title="Total contacts imported"
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>
        : !chart.options.labels.length && !loading
          ? <div className={classes.notResult}>No Data Found</div>
          : (
            <Chart
              options={chart.options}
              series={chart.series}
              type="radialBar"
              height={380}
              width="100%"
            />
          )}

    </AnalyticsChartWrapper>
  );
};

export default TotalContactsImports;
